import { handleActions } from "redux-actions";
import { ATS_EXPORT } from "../constants/action-types";
import { IFetchStoreState, progressActions, initialFetchState, updateActions } from "./base-reducers";

export interface IAtsCustomTemplateExport extends IFetchStoreState<{ id: string }> {}

export const atsExport = handleActions<IAtsCustomTemplateExport>(
    {
        ...progressActions(ATS_EXPORT.INITIATE, "isFetching"),
        ...updateActions(ATS_EXPORT),
    } as any,
    { ...initialFetchState, isFetching: false },
);
